/**
 * 외부 patch url 인지 판단
 * FIXME: live url 까지 판단하도록 수정
 */
export default function isExternalUrl(url: string) {
	return /^(http|https)?:\/\//.test(url)
}
